
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Language } from '../types';

interface SEOHeadProps {
  title: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'product' | 'article';
  schemaData?: any; // Structured data object
}

export const SEOHead: React.FC<SEOHeadProps> = ({ 
  title, 
  description = "MEITAI Instruments - Leading exporter of industrial instrumentation to the Middle East, Africa, and Southeast Asia.",
  keywords = "industrial instruments, flowmeters, pressure transmitters, level sensors, MEITAI, automation, process control",
  image = "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=1200",
  url = typeof window !== 'undefined' ? window.location.href : 'https://meitai-instruments.com',
  type = 'website',
  schemaData
}) => {
  const baseUrl = url.split('?')[0];
  
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "MEITAI Instruments",
    "url": "https://meitai-instruments.com",
    "logo": "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=200",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+86-13149898413",
      "contactType": "sales",
      "areaServed": ["AE", "SA", "NG", "VN", "ID", "TH"],
      "availableLanguage": ["en", "Arabic", "French", "Chinese"]
    }
  };

  const finalSchema = schemaData || defaultSchema;

  return (
    <Helmet>
      <title>{`${title} | MEITAI Instruments`}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />

      {Object.values(Language).map(lang => {
        const hreflang = lang === Language.ZH ? 'zh-Hans' : lang;
        const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
        params.set('lang', lang);
        return (
          <link key={lang} rel="alternate" hrefLang={hreflang} href={`${baseUrl}?${params.toString()}`} />
        );
      })}
      
      <link 
        rel="alternate" 
        hrefLang="x-default" 
        href={`${baseUrl}?lang=${Language.EN}`} 
      />

      <script type="application/ld+json">
        {JSON.stringify(finalSchema)}
      </script>
    </Helmet>
  );
};
